export default __webpack_public_path__ + "static/media/third.04f866ca.jpg";